import { render } from "./IntegrationWidgetsBrowserModal.vue?vue&type=template&id=e656bfb0&scoped=true"
import script from "./IntegrationWidgetsBrowserModal.vue?vue&type=script&lang=ts"
export * from "./IntegrationWidgetsBrowserModal.vue?vue&type=script&lang=ts"

import "./IntegrationWidgetsBrowserModal.vue?vue&type=style&index=0&id=e656bfb0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e656bfb0"

export default script